import { Link } from 'react-router-dom';
import { languages, getLocalePath, type Locale } from '../i18n/ui';

interface Props {
  currentLocale: Locale;
}

export function LangToggle({ currentLocale }: Props) {
  const otherLocales = (Object.keys(languages) as Locale[]).filter((l) => l !== currentLocale);

  return (
    <div className="lang-toggle">
      <button className="lang-current mono" aria-label="Mudar idioma / Change language">
        {languages[currentLocale]}
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M2 4l3 3 3-3" />
        </svg>
      </button>
      <div className="lang-dropdown">
        {otherLocales.map((locale) => (
          <Link key={locale} to={getLocalePath(locale)} className="lang-option mono">
            {languages[locale]}
          </Link>
        ))}
      </div>
    </div>
  );
}
